import React from 'react';
import PropTypes from 'prop-types';

import { TextField } from '@oca/ui';

export function TextFieldWrapper({ input, meta, helperText, ...rest }) {
  const showError =
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) &&
    meta.touched;

  return (
    <TextField
      {...rest}
      {...input}
      error={showError}
      helperText={showError ? meta.error || meta.submitError : helperText}
    />
  );
}

TextFieldWrapper.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any,
  }).isRequired,
  meta: PropTypes.shape({
    submitError: PropTypes.any,
    dirtySinceLastSubmit: PropTypes.bool,
  }).isRequired,
  // eslint-disable-next-line react/require-default-props
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
